import { Box, LinearProgress, Typography } from '@mui/material'
import { useStyles } from './styles'
import { AnswerData } from '../../../../../../../../service/questionarie/response'
import { useTranslation } from 'react-i18next'
import { CSSProperties, useState } from 'react'
import dayjs from 'dayjs'
import { Constants } from '../../../../../../../../utils/constants'

export const OptionQuestion = ({description, score, amountSelected,  amountRecurrence, percentage, correctOption, answersOpen, iconUrl, recurrences}:AnswerData) => {
    const styles = useStyles()
    const { t } = useTranslation()
    
  return (
    <>
    <Box sx={styles.container}>
      { answersOpen?.length===0 && (description || iconUrl) && (
        <>
        <Box sx={styles.title}>
          {!!iconUrl && <img style={styles.image as CSSProperties} src={iconUrl} alt="icon_multiple" />}
          <Typography variant='mediumBold' sx={styles.titleAnswer}>{`${description ? description:''} - ${score} ${correctOption ? `- ${t('Questionarie.fields.correctOption')}`  : ''}`}</Typography>
        </Box>
        
        <Box sx={styles.progressAndAlert}>
          <Box sx={styles.flexProgressAndAlert}>
            <Box sx={styles.progressContainer({progress:percentage})}>
              <Typography>{percentage}% ({amountSelected})</Typography>
                <LinearProgress 
                    variant="determinate" 
                    value={percentage} 
                />
            </Box> 
            {!!(amountRecurrence > 0) && <Typography sx={styles.alerts}>{amountRecurrence} {t('Questionarie.fields.recurrenceAlerts')}</Typography>}    
          </Box>
        </Box>
        </>
      )}
      { answersOpen?.length!==0 && !iconUrl && (
        <Box sx={styles.openAnswerContainer}>
          <Box sx={styles.freeAnswerText}>
            {answersOpen.map(answer=>(
                <Typography sx={styles.displayBlock} variant='mediumBold'>{`${answer} - ${score} ${correctOption ? `- ${t('Questionarie.fields.correctOption')}`  : ''}`}</Typography>
            ))}
          </Box>
          
          <Box sx={styles.title}>
            <Box>
              {!!(amountRecurrence > 0) && <Typography sx={styles.freeAlerts}>{amountRecurrence} {t('Questionarie.fields.recurrenceAlerts')}</Typography>}
                {recurrences?.length <= 3 && recurrences?.map((recurrence,index) => (
                  <Typography sx={styles.alertText} key={index}>{recurrence}</Typography>
                ))}
            </Box>
          </Box>
        </Box>
      )}
      { answersOpen?.length===0 && !description && !iconUrl && (
        <Typography variant='mediumBold'>{t('Questionarie.fields.noDataFound')}</Typography>
      )}
    </Box>
    {
      recurrences?.length!=0/*  && recurrences?.length <= 3 */ && (
      <Box sx={[(recurrences?.length  <= 3 /*&& answersOpen?.length===0 */) ? styles.container:null]}>
        <Box sx={[(recurrences?.length <= 3 /*&& answersOpen?.length===0 */) ? styles.smallDate:styles.bigDate]}>
          {recurrences?.map((recurrence,index) => (
            <Typography key={index} sx={[styles.alertText, recurrences?.length <= 3 ? null:styles.marginRigt, (answersOpen?.length!==0 && recurrences?.length <= 3) ? styles.hiden:null]}>
              {`${(index !== 0 && recurrences?.length > 3) ? ' - ' : ''}${recurrence}`}
            </Typography>
          ))}
          </Box>
      </Box>
      )
    }
  </>
  )
}
